import { AreaChart } from "@mantine/charts";
import { LoadingOverlay, Paper, Stack, Text } from "@mantine/core";

const GlobalEngagement = ({ stats, loading, statsOneMonth }) => {
  const statsToUse = statsOneMonth || stats
  
  return (
    <Paper
      component={Stack}
      gap={0}
      p={"lg"}
      px={"xl"}
      radius={"md"}
      bg={"#fff"}
      flex={stats.connection_per_day.length > 90 ? undefined : 1}
      pos={"relative"}
      w={stats.connection_per_day.length > 60 ? "100%" : "auto"}
    >
      <LoadingOverlay visible={loading} />
      <Text size="xl" mb={16}>
        Engagement global
      </Text>

      <AreaChart
        h={120}
        data={statsToUse.connection_per_day.map((x) => ({
          ...x,
          date: x.date.substring(5, 10).split("-").reverse().join("-"),
        }))}
        dataKey="date"
        series={[
          {
            name: "number_connections",
            label: "Engagements",
            color: "indigo.6",
          },
        ]}
        curveType="monotone"
        tickLine="none"
        gridAxis="xy"
        withYAxis={false}
      />
    </Paper>
  );
};

export default GlobalEngagement;
